import script from "./AddEditBaseRecipes.vue?vue&type=script&setup=true&lang=js"
export * from "./AddEditBaseRecipes.vue?vue&type=script&setup=true&lang=js"

import "./AddEditBaseRecipes.vue?vue&type=style&index=0&id=33b895ab&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33b895ab"]])

export default __exports__